import * as React from 'react';
import { UserAvatar } from '@balance-web/avatar';
import { DropdownMenu, MenuItem } from '@balance-web/dropdown';
import { ChevronDownIcon, ChevronUpIcon } from '@balance-web/icon';
import { Flex } from '@balance-web/flex';
import { Box } from '@balance-web/box';
import { Inline } from '@balance-web/inline';
import { Visible } from '@balance-web/media-query';
import { Text } from '@balance-web/text';

import { Config } from '../../../services/Config';

export type UserInfoProps = {
  firstName: string;
  lastName: string;
  showHelp?: boolean;
  logoutMenuLabel?: string;
  helpMenuLabel?: string;
  showLogout?: boolean;
  onLogoutClick?: () => void;
  onHelpClick?: () => void;
};

export const UserInfo: React.FC<UserInfoProps> = (props) => {
  const {
    showHelp,
    showLogout,
    helpMenuLabel = 'Help & Support',
    logoutMenuLabel = 'Return to Portal',
    firstName,
    lastName,
    onLogoutClick,
    onHelpClick,
  } = props;

  const handleHelpClick = () => {
    if (typeof onHelpClick !== 'function') {
      return;
    }
    onHelpClick();
  };
  const handleLogoutClick = () => {
    if (typeof onLogoutClick !== 'function') {
      return;
    }
    onLogoutClick();
  };

  if (!firstName && !lastName) {
    return null;
  }

  const fullname = [firstName, lastName].filter(Boolean).join(' ');

  return (
    <Flex alignItems="center" flexGrow={0}>
      {fullname ? (
        <DropdownMenu
          trigger={({ triggerProps, isOpen }) => {
            const Icon = isOpen ? ChevronUpIcon : ChevronDownIcon;
            return (
              <Inline
                alignY="center"
                as="button"
                cursor="pointer"
                type="button"
                userSelect="none"
                {...triggerProps}
              >
                <UserAvatar name={fullname} size="small" />
                <Visible above="small">
                  <Box marginX="small">
                    <Text
                      align="left"
                      overflowStrategy="nowrap"
                      size="small"
                      weight="medium"
                    >
                      {fullname}
                    </Text>
                  </Box>
                </Visible>
                <Icon color="textBody" size="small" />
              </Inline>
            );
          }}
        >
          {showHelp && handleHelpClick && (
            <MenuItem label={helpMenuLabel} onClick={handleHelpClick} />
          )}
          {showLogout && handleLogoutClick && (
            <MenuItem label={logoutMenuLabel} onClick={handleLogoutClick} />
          )}
          <Inline alignY="center" paddingTop="small" paddingX="large">
            <Text color="textBody" size="xsmall">
              Version: {Config.APPLICATION_VERSION}
            </Text>
          </Inline>
        </DropdownMenu>
      ) : null}
    </Flex>
  );
};
